  <div class="p-3 drug-sample-card" [ngClass]="{'drug-sample-card-shadow' : callingfrom!='GRAND_ROUND'}">
    <!-- {{drugListObj | json}} -->
    <div class="row ">
      <div class="cursor-pointer" (click)="navigateToDetail(drugListObj?.drug_id)"
        [ngClass]='{"col-12" : type=="order", "col-md-2 col-4 pr-0":type !="order" && !(callingfrom=="search-list" || callingfrom=="GRAND_ROUND"), "col-3 pr-0":callingfrom=="search-list" || callingfrom=="GRAND_ROUND"}'>
        <div class="position-relative text-center">
          <img loading="lazy" class="img-border" src={{drugListObj?.logo}}
            onerror="this.src='assets/themes/icons/banner-placeholder.svg'" [width]="type != 'order' ? 100 : 308" [height]="type != 'order' ? 100 : 228"/>
        </div>
      </div>
      <div class="pt-2" [ngClass]='{"col-12":type=="order" , "col-md-10 col-8":type!="order" && callingfrom !="search-list" && callingfrom!="GRAND_ROUND", "col-9":callingfrom=="search-list"  || callingfrom=="GRAND_ROUND"}'>
        <div class="clearfix cursor-pointer mb-3" (click)="navigateToDetail(drugListObj?.drug_id)">
          <div class="float-left drug-sample-title">
            <p class="heading-4">
              {{drugListObj?.name}}
            </p>
          </div>
          <div class="float-right" *ngIf="is_ordered==0">
            <img src="assets/themes/icons/Arorrow.svg" width="16" alt="arrow">
          </div>
        </div>

        <div class="row">
          <div class="pt-md-2 cursor-pointer"
            [ngClass]="{'col-12': drugListObj?.order_allow?.order_button_flag!=1, 'col-md-7': drugListObj?.order_allow?.order_button_flag==1}"
            (click)="navigateToDetail(drugListObj?.drug_id)">

            <p>
              <span class="position-relative mr-2 paragraph">
                <img loading="lazy" class="mr-2 drug-sample-logo rounded-circle" src={{drugListObj?.pharma_logo}}
                  onerror="this.src='assets/themes/icons/channel-placeholder.svg'" />
                 <span class="color-grey-700">{{drugListObj?.pharma_name}}</span>
              </span>
                <!-- <span class="drug-chip-wrapper pl-2 chip small filled success">
                  {{drugListObj?.paid_text}}
                </span> -->
            </p>
            <p class="primary-small mt-2" *ngIf="drugListObj?.order_allow?.msg!='' && is_ordered==0">
              {{drugListObj?.order_allow?.msg}}</p>
          </div>
          <div class="col-md-5 pl-0 text-right" *ngIf="is_ordered==0">
            <button (click)="showDrugForm(drugListObj?.drug_id  )"
              *ngIf="drugListObj?.order_allow?.order_button_flag===1 && is_ordered===0"
              class="btn-design medium outline h-auto mt-2"
              [ngClass]='{"small":callingfrom=="GRAND_ROUND"}'>
              {{drugListObj.order_allow.order_button_text}}
              <span *ngIf="mls?.is_lskey_display===1">(drug_sample_card.key1)</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>